import '../../styles/blocks/acf/map-display.scss';

(function () {
/** Snazzy Maps grayscale style from legacy contact map. */
const MAP_STYLES = [
  { stylers: [{ visibility: 'on' }, { saturation: -100 }, { gamma: 0.54 }] },
  { featureType: 'road', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', stylers: [{ color: '#4d4946' }] },
  { featureType: 'poi', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', elementType: 'labels.text', stylers: [{ visibility: 'simplified' }] },
  { featureType: 'road', elementType: 'geometry.fill', stylers: [{ color: '#ffffff' }] },
  { featureType: 'road.local', elementType: 'labels.text', stylers: [{ visibility: 'simplified' }] },
  { featureType: 'water', elementType: 'labels.text.fill', stylers: [{ color: '#ffffff' }] },
  { featureType: 'transit.line', elementType: 'geometry', stylers: [{ gamma: 0.48 }] },
  { featureType: 'transit.station', elementType: 'labels.icon', stylers: [{ visibility: 'off' }] },
  { featureType: 'road', elementType: 'geometry.stroke', stylers: [{ gamma: 7.18 }] },
];

function getPrimaryColor() {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-primary')
    .trim();

  return value || '#e85d04';
}

function buildMarkerIcon(color) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" viewBox="0 0 32 42" aria-hidden="true">
    <path fill="${color}" d="M16 0C7.163 0 0 7.163 0 16c0 11.046 16 26 16 26s16-14.954 16-26C32 7.163 24.837 0 16 0z"/>
    <circle fill="#ffffff" cx="16" cy="16" r="6"/>
  </svg>`;

  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`,
    scaledSize: new google.maps.Size(32, 42),
    anchor: new google.maps.Point(16, 42),
  };
}

function initMap(el) {
  const lat = parseFloat(el.dataset.lat, 10);
  const lng = parseFloat(el.dataset.lng, 10);
  const zoom = parseInt(el.dataset.zoom, 10) || 15;

  if (Number.isNaN(lat) || Number.isNaN(lng)) {
    return;
  }

  const center = { lat, lng };
  const map = new google.maps.Map(el, {
    zoom,
    center,
    styles: MAP_STYLES,
    disableDefaultUI: false,
    mapTypeControl: false,
    streetViewControl: false,
    fullscreenControl: true,
  });

  new google.maps.Marker({
    position: center,
    map,
    icon: buildMarkerIcon(getPrimaryColor()),
  });
}

let mapsLoader;

function loadGoogleMaps() {
  if (window.google?.maps) {
    return Promise.resolve();
  }

  if (mapsLoader) {
    return mapsLoader;
  }

  const apiKey = window.pvtlMapDisplay?.apiKey;
  if (!apiKey) {
    return Promise.reject(new Error('Google Maps API key is not configured.'));
  }

  mapsLoader = new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${encodeURIComponent(apiKey)}`;
    script.async = true;
    script.defer = true;
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Failed to load Google Maps.'));
    document.head.appendChild(script);
  });

  return mapsLoader;
}

function boot() {
  const maps = document.querySelectorAll('[data-pvtl-map]');
  if (!maps.length) {
    return;
  }

  loadGoogleMaps()
    .then(() => {
      maps.forEach(initMap);
    })
    .catch(() => {
      // Missing API key or network failure — map container stays empty.
    });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
})();
